<button type="button" [ngClass]="color" class="btn rounded-pill " [class.w-100]="btnFullWidth" [disabled]="disabled" (click)="handleClick()">
  {{title}}
</button>
